<template>
  <ClientOnly>
    <noscript>
      <div v-if="grade && grade !== null">
        {{ i18n.price(grade.price) }}
      </div>
      <div v-for="group in pickers" :key="group.label">
        <p>{{ group.label }}</p>
        <ul>
          <li v-for="item in group.items" :key="item.label">
            <RevLink :to="item.link">{{ item.label }}</RevLink>
          </li>
        </ul>
      </div>
    </noscript>

    <template #fallback>
      <noscript>
        <div v-if="grade && grade !== null">
          {{ i18n.price(grade.price) }}
        </div>
        <div v-for="group in pickers" :key="group.label">
          <p>{{ group.label }}</p>
          <ul>
            <li v-for="item in group.items" :key="item.label">
              <RevLink :to="item.link">{{ item.label }}</RevLink>
            </li>
          </ul>
        </div>
      </noscript>
    </template>
  </ClientOnly>
</template>

<script lang="ts" setup>
import { productAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
// Eslint is not finding our RevLink in the noscript tag...
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { RevLink } from '@ds/components/Link'

defineProps<{
  pickers: productAPI.GetPickersResponse['pickers']
  grade?: productAPI.GetBestOffersResponse[number] | null
}>()

// Eslint is not finding the i18n in the noscript tag...
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const i18n = useI18n()
</script>
